(() => {
  const existing = window.LorolivoRewards;
  if (existing && typeof existing.refresh === 'function') {
    existing.refresh();
    return;
  }

  const milestones = [
    { amount: 3000, label: '1 € de saldo Lorolivo' },
    { amount: 3900, label: '2 € de saldo Lorolivo y envío gratuito' },
    { amount: 6000, label: 'AOVE ecológico 250 ml + 4 € de saldo Lorolivo' },
    { amount: 9000, label: 'AOVE ecológico 250 ml + almendras + 8 € de saldo Lorolivo' },
    { amount: 12000, label: 'AOVE ecológico 500 ml + almendras + nueces + 15 € de saldo Lorolivo' },
  ];
  const maxReward = 12000;
  const money = (cents) => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(cents / 100);

  const render = (element, totalOverride) => {
    const total = Math.max(0, Number.isFinite(totalOverride) ? totalOverride : Number(element.dataset.cartTotal) || 0);
    const achieved = milestones.filter((item) => total >= item.amount).at(-1);
    const next = milestones.find((item) => total < item.amount);
    const current = element.querySelector('[data-lorolivo-rewards-current]');
    const nextText = element.querySelector('[data-lorolivo-rewards-next]');
    const fill = element.querySelector('[data-lorolivo-rewards-fill]');
    const track = element.querySelector('[role="progressbar"]');

    if (current) current.textContent = achieved ? '¡Conseguido! ' + achieved.label + '.' : 'Añade productos y empieza a conseguir recompensas.';
    if (nextText) nextText.textContent = next ? 'Te faltan ' + money(next.amount - total) + ' para conseguir ' + next.label + '.' : 'Has alcanzado la recompensa máxima.';
    if (fill) fill.style.width = Math.min(100, (total / maxReward) * 100) + '%';
    if (track) {
      track.setAttribute('aria-valuenow', String(Math.min(total, maxReward)));
      track.setAttribute('aria-valuetext', next ? money(next.amount - total) + ' para ' + next.label : 'Recompensa máxima alcanzada');
    }
  };

  let pending;
  const renderAll = (total) => document.querySelectorAll('[data-lorolivo-rewards]').forEach((element) => render(element, total));
  const refresh = () => {
    if (pending) return pending;
    const root = window.Shopify?.routes?.root || '/';
    pending = fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : Promise.reject())
      .then((cart) => renderAll(Number(cart.total_price) || 0))
      .catch(() => renderAll())
      .finally(() => { pending = null; });
    return pending;
  };
  const bind = () => document.querySelectorAll('cart-form').forEach((form) => {
    if (form.dataset.lorolivoRewardsBound === 'true') return;
    form.dataset.lorolivoRewardsBound = 'true';
    form.addEventListener('cart-updated', () => setTimeout(refresh, 0));
  });
  const observer = new MutationObserver(() => { bind(); refresh(); });
  window.LorolivoRewards = { refresh };
  bind();
  refresh();
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
})();